import { slice, min, max, indexOf, last, curry } from 'ramda';

/**
 * Handles multiple selections in a list of items.
 * Returns a list of items that are in between the last selected item and the new selected item (included).
 *
 * The current implementation works additive. Already selected items will not be removed from the list.
 *
 * @param {[*]} items List of all items.
 * @param {[*]} selectedItems List of currently selected items.
 * @param {*} currentItem Newly selected item
 */
const getMultiSelectedItems = curry((items, selectedItems, currentItem) => {
  const lastIndex = indexOf(last(selectedItems), items);
  const currentIndex = indexOf(currentItem, items);

  return slice(max(min(lastIndex, currentIndex), 0), max(lastIndex, currentIndex) + 1, items);
});

export default getMultiSelectedItems;
